let lastScrollPos = 0;
let lastScrollDownToPos = 0;
let headerBottomPosition;
let $window;
let $document;
let $body;
let $header;
let $headerAd;
let $userDropdown;
let fixedTimeout;
let expandedTimeout;
let expandedSearchTimeout;
let windowWidth;
let headerAdHeight;

function onResize() {
  if ($window.innerWidth() !== windowWidth) {
    setHeaderBottomPosition();
  }
}

function checkHeaderAd(iteration = 1) {
  headerAdHeight = $headerAd.outerHeight();
  setTimeout(() => {
    const headerHeightAfterWaiting = $headerAd.outerHeight();
    if (iteration === 4 && !$headerAd.find('iframe').length) {
      $headerAd.remove();
    }
    if (headerAdHeight !== headerHeightAfterWaiting) {
      return setHeaderBottomPosition();
    }
    if (iteration <= 3) {
      checkHeaderAd(iteration + 1);
      return;
    }
  }, 500);
}

function setHeaderBottomPosition() {
  $body.removeClass('header-fixed');
  $header.removeClass('Header--fixed-ready').removeClass('Header--fixed');
  windowWidth = $window.innerWidth();
  headerBottomPosition = $header.offset().top + $header.outerHeight();
}

function checkScroll() {
  const currentScrollPos = $window.scrollTop();
  // If the current scroll position is larger (past) the the bottom of the header
  const headerIsFixed = currentScrollPos > headerBottomPosition;
  if (headerIsFixed) {
    $header.addClass('Header--fixed');
    if (!$header.hasClass('Header--fixed-ready')) {
      $body.addClass('header-fixed');
      fixedTimeout = setTimeout(() => $header.addClass('Header--fixed-ready'), 10);
    }
  } else {
    clearTimeout(fixedTimeout);
    if ($header.hasClass('Header--fixed-ready')) {
      $body.removeClass('header-fixed');
      $header.removeClass('Header--fixed-ready').removeClass('Header--fixed');
    }
  }

  if (!$body.hasClass('expanded-menu-open')) {
    // Check if the current scroll position is less then the last i.e. user scrolls up
    $header.toggleClass('Header--fixed-show', headerIsFixed && currentScrollPos < lastScrollDownToPos - 20);
  }
  if (currentScrollPos > lastScrollPos) {
    lastScrollDownToPos = currentScrollPos;
  }
  lastScrollPos = currentScrollPos;
}

function toggleExpandedMenu(e) {
  e.preventDefault();
  e.stopPropagation();

  const open = $body.hasClass('expanded-menu-open');
  if (!open) {
    openExpandedMenu();
  }
  else {
    closeExpandedMenu();
  }
}

function openExpandedMenu() {
  clearTimeout(expandedTimeout);
  $body.addClass('expanded-menu-open-ready');
  expandedTimeout = setTimeout(() => {
    $body.addClass('expanded-menu-open')
    expandedTimeout = setTimeout(() => $header.removeClass('Header--fixed-show'), 200);
  }, 10);
  $window.css('overflow', 'hidden');
  //$body.css('overflow', 'hidden');
  $document.on('keyup', closeExpandedMenuOnEsc);
}

function closeExpandedMenu() {
  clearTimeout(expandedTimeout);
  $body.removeClass('expanded-menu-open');
  expandedTimeout = setTimeout(() => $body.removeClass('expanded-menu-open-ready'), 200);
  $window.css('overflow', 'initial');
  $body.css('overflow', 'initial');
  $document.off('keyup', closeExpandedMenuOnEsc);
}

function closeExpandedMenuOnEsc(e) {
  if(e.key === 'Escape') {
    closeExpandedMenu();
  }
}

function handleSubmenuMenuToggle(e) {
  const self = $(e.currentTarget);
  self.toggleClass('open');
  if (self.hasClass('open')) {
    self.children('.sub-menu').slideDown({
      duration: 150,
      start: function () {
        $(this).css('display', 'flex');
      },
    });
  } else {
    self.children('.sub-menu').slideUp(150);
  }
}

function toggleSearch(e) {
  e.preventDefault();
  const open = $body.hasClass('search-open');
  if (!open) {
    openSearch();
  }
  else {
    closeSearch();
  }
}

function openSearch() {
  clearTimeout(expandedSearchTimeout);
  $body.addClass('search-open-ready');
  $('.Search-expanded .Inline-form__field').focus();
  expandedSearchTimeout = setTimeout(() => {
    $body.addClass('search-open')
  }, 10);
  $window.css('overflow', 'hidden');
  $body.css('overflow', 'hidden');
  $document.on('keyup', closeSearchOnEsc);
}

function closeSearch() {
  clearTimeout(expandedSearchTimeout);
  $body.removeClass('search-open');
  expandedSearchTimeout = setTimeout(() => $body.removeClass('search-open-ready'), 200);
  $window.css('overflow', 'initial');
  $body.css('overflow', 'initial');
  $document.off('keyup', closeSearchOnEsc);
}

function closeSearchOnEsc(e) {
  if(e.key === 'Escape') {
    closeSearch();
  }
}

function toggleUserDropdown(e) {
  e.preventDefault();
  e.stopPropagation();

  if (!$userDropdown) {
    $userDropdown = $('.User-dropdown');
  }

  const open = $userDropdown.hasClass('User-dropdown--open');
  if (!open) {
    openUserDropdown();
  }
  else {
    closeUserDropdown();
  }

}

function openUserDropdown() {
  $userDropdown.addClass('User-dropdown--open');
  $userDropdown.find('.User-dropdown__dropdown').slideDown(100);
  $body.on('click', closeUserDropdown);
  $document.on('keyup', closeUserDropdownOnEsc);
}

function closeUserDropdown() {
  $userDropdown.removeClass('User-dropdown--open');
  $userDropdown.find('.User-dropdown__dropdown').slideUp(100);
  $body.off('click', closeUserDropdown);
  $document.off('keyup', closeUserDropdownOnEsc);
}

function closeUserDropdownOnEsc(e) {
  if(e.key === 'Escape') {
    closeUserDropdown();
  }
}

export default function() {
  $window = $(window);
  $document = $(window.document);
  $body = $('body');
  $header = $('.Header');
  $headerAd = $('.External-ad--header');
  $body
    .on('click', '.menu-item-has-children', handleSubmenuMenuToggle)
    .on('click', '[data-toggle="menu"], [href="#open-menu"]', toggleExpandedMenu)
    .on('click', '[data-toggle="search"]', toggleSearch)
    .on('click', '[data-toggle="user-dropdown"]', toggleUserDropdown)
    .on('click', '.Search-expanded form', (e) => e.stopPropagation());

  if ($headerAd.length) {
    checkHeaderAd();
  }

  // Replace all links with span on menu item that has children in primary menu
  $('.Primary-menu .menu-item-has-children > a').each(function() {
    const self = $(this);
    self.replaceWith('<span>' + self.text() + '</span>');
  })

  //Add class to last taxonomy menu item
  $('.Primary-menu > .menu-item-type-taxonomy').last().addClass('is-last-child');

  setHeaderBottomPosition();
  $window.on('resize', onResize);
  $window.on('scroll', checkScroll);
}



// WEBPACK FOOTER //
// ./scripts/components/header.js